// extracted by mini-css-extract-plugin
export default {"modalForm":"RankingCreateForm_modalForm__AS-up","selectWrapper":"RankingCreateForm_selectWrapper__qB3fz","btnSubmit":"RankingCreateForm_btnSubmit__kjNEz"};